import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import sesion from './modules/sesion';
import usuarios from './modules/usuarios';
import riesgos from './modules/riesgos';
import empresas from './modules/empresas';
import areas from './modules/areas';
import contratos from './modules/contratos';
import inventarios from './modules/inventarios';
import workflows from './modules/workflows';
import general from './modules/general';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    sesion,
    usuarios,
    riesgos,
    empresas,
    areas,
    contratos,
    inventarios,
    workflows,
    general
  },
  strict: debug,
});
